import { DashboardContainer } from '../../../components/dashboard/DashboardContainer';
import { ContactInformation } from '../../../components/contactInfo/ContactInformation';

const ContactUS = () => {
  return (
    <DashboardContainer>
      <ContactInformation />
    </DashboardContainer>
  );
};

export default ContactUS;
